"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginForm = void 0;
const button_1 = require("../../view-components/buttons/button");
const input_1 = require("../../view-components/inputs/input");
const label_1 = require("../../view-components/label/label");
const submit_form_1 = require("./submit-form");
class LoginForm {
    constructor(id) {
        this.form = document.createElement('form');
        this.form.id = id;
    }
    render() {
        this.form.classList.add(this.form.id);
        this.form.name = this.form.id;
        this.form.className = this.form.id;
        const submitBut = button_1.ButtonEl.render('submit-form', 'Login');
        const inputUsername = input_1.inputEl.render('text', 'name');
        const labelUsername = label_1.labelEl.render('name');
        const alertAfterUsername = document.createElement('p');
        alertAfterUsername.id = 'name-alert';
        const inputSurname = input_1.inputEl.render('text', 'surname');
        const labelSurname = label_1.labelEl.render('surname');
        const alertAfterSurname = document.createElement('p');
        alertAfterSurname.id = 'surname-alert';
        const alertFormHTML = document.createElement('p');
        alertFormHTML.id = 'form-alert';
        this.form.append(labelUsername);
        this.form.append(inputUsername);
        this.form.append(alertAfterUsername);
        this.form.append(labelSurname);
        this.form.append(inputSurname);
        this.form.append(alertAfterSurname);
        this.form.append(submitBut);
        this.form.append(alertFormHTML);
        submitBut.addEventListener('click', submit_form_1.submitForm);
        return this.form;
    }
}
exports.LoginForm = LoginForm;
